import { DateTime } from "luxon";
import { Trainings } from "./generated/graphql";

export type RegistrationFormInputType = "text" | "date" | "email" | "text_area";

export interface RegistrationFormInput {
  name: string;
  placeholder: string;
  required: boolean;
  type: "text" | "date";
  rank: number;
}

export const currencyFormatter = Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export function dateRange(
  startDate: Date | null,
  endDate: Date | null
): string {
  function format(date: DateTime) {
    return date.toFormat("LLL d, yyyy");
  }

  const start = startDate ? DateTime.fromJSDate(startDate) : null;
  const end = endDate ? DateTime.fromJSDate(endDate) : null;

  let formatted: string;
  if (!start || !end) {
    formatted = "Ongoing";
  } else if (start.equals(end)) {
    formatted = format(start);
  } else {
    formatted = `${format(start)} to ${format(end)}`;
  }

  return formatted;
}

export function trainingCostDisplay(
  {
    price,
    downpayment,
    downpayment_cutoff_days,
    start_date,
    payment_plan_dates,
  }: Pick<
    Trainings,
    | "downpayment"
    | "price"
    | "downpayment_cutoff_days"
    | "start_date"
    | "payment_plan_dates"
  >,
  allowsDownpayment: boolean | undefined
): string {
  if (price === 0) return "Free";

  if (allowsDownpayment && !!downpayment) {
    const sortedPaymentDates = (payment_plan_dates as string[])
      .map((s) =>
        DateTime.fromISO(s, {
          zone: "America/Los_Angeles",
        })
      )
      .sort();

    const diff = sortedPaymentDates[0].diff(DateTime.local(), "days");

    const diffUnit = diff.days > 1 ? "days" : "day";

    return `${currencyFormatter.format(
      downpayment / 100
    )} due today and ${currencyFormatter.format(
      (price - downpayment) / 100
    )} due in ${sortedPaymentDates.length} installments in ${Math.trunc(
      diff.days
    )} ${diffUnit}`;
  }

  return currencyFormatter.format(price / 100);
}
